<template>
  <el-dialog
    title
    :visible.sync="show"
    :close-on-click-modal="false"
    width="550px"
    bodyHeight="400px"
    class="user-bind-modal"
    @close="onChange"
  >
    <div slot="title">
      {{ drawRow.type === 'add' ? $t('shop-site::email::addEmail_title') : $t('shop-site::email::editEmail_title') }}
    </div>

    <el-row :gutter="16" v-show="!showEmailForm">
      <el-col :span="8" v-for="item in emailList" :key="item.mailboxType">
        <div class="emailType">
          <img :src="item.imageUrl" @click="selectDefaultEmail(item)" />
        </div>
      </el-col>
    </el-row>

    <el-form
      v-show="showEmailForm"
      class="email-body"
      ref="form"
      :model="params"
      :rules="rules"
      label-width="150px"
      v-loading="loading"
      hide-required-asterisk
    >
      <div class="sec-box no-bg">
        <el-form-item
          label-width="110px"
          :label="$t('shop-site::email::table_shop') + '：'"
          prop="shopId"
          v-if="drawRow.type === 'add'"
        >
          <el-select
            v-model="params.shopId"
            :popperAppendToBody="false"
            filterable
            class="input-item"
            :disabled="drawRow.type !== 'add'"
            :placeholder="$t('shop-site::email::placeholder_shop')"
            @change="changeShop"
          >
            <el-option v-for="item in shopIds" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="110px" :label="$t('shop-site::email::table_shop') + '：'" v-else>
          {{ $dataCheck(params.shopName) }}
        </el-form-item>
        <el-form-item label-width="110px" :label="$t('shop-site::email::form_platform') + '：'" prop="platform">
          <el-select
            v-model="params.platform"
            :popperAppendToBody="false"
            :disabled="!!params.shopId"
            filterable
            class="input-item"
            :placeholder="$t('shop-site::email::placeholder_platform')"
          >
            <el-option
              v-for="item in platformLists"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="110px" :label="$t('shop-site::email::form_staff') + '：'" prop="staffId">
          <el-select
            v-model="params.staffId"
            :popperAppendToBody="false"
            filterable
            class="input-item"
            :placeholder="$t('shop-site::email::placeholder_staff')"
          >
            <el-option v-for="item in users" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="110px" :label="$t('shop-site::email::form_account') + '：'" prop="inUser">
          <el-input
            v-model.trim="params.inUser"
            class="input-item"
            :placeholder="$t('shop-site::email::placeholder_account')"
          ></el-input>
        </el-form-item>
        <el-form-item label-width="110px" prop="inPassword">
          <div slot="label" style="display: inline-block">
            {{ $t('shop-site::email::form_password') }}：
            <el-tooltip class="item" effect="dark" placement="bottom">
              <span slot="content">
                {{ $t('shop-site::email::qq_tip') }}
                <br />
                <a href="https://service.mail.qq.com/cgi-bin/help?subtype=1&&id=28&&no=1001256" target="_blank">
                  https://service.mail.qq.com/cgi-bin/
                  <br />
                  help?subtype=1&&id=28&&no=1001256
                </a>
                <br />
                {{ $t('shop-site::email::auth_tip') }}
              </span>
              <i class="icon-a-01wenhao iconfont-el" v-show="params.inServer && params.inServer.includes('qq')"></i>
            </el-tooltip>
          </div>
          <el-input
            v-model.trim="params.inPassword"
            class="input-item"
            type="password"
            :placeholder="$t('shop-site::email::placeholder_password')"
            :show-password="true"
          ></el-input>
        </el-form-item>
      </div>
      <p style="text-align: center; margin-bottom: 16px; padding: 10px 0; background: #f9f9f9">
        <span @click="showMore = !showMore" style="cursor: pointer">
          {{ $t('shop-site::email::moreSetting') }}
          <i class="iconfont down-icon iconicon_arrow02" :class="{ 'rotate-arrow': showMore }"></i>
        </span>
      </p>
      <div class="sec-box" v-show="showMore">
        <div class="sec-header">{{ $t('shop-site::email::sendSetting') }}</div>
        <el-form-item :label="$t('shop-site::email::table_sendType') + '：'" prop="outAccountType">
          <el-select
            v-model="params.outAccountType"
            :popperAppendToBody="false"
            class="input-item"
            :placeholder="$t('shop-site::email::placeholder_emailType')"
            :popper-append-to-body="false"
          >
            <el-option v-for="item in emailTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('shop-site::email::table_sendAddress') + '：'" prop="outServer">
          <el-input
            v-model.trim="params.outServer"
            class="input-item"
            :placeholder="$t('shop-site::email::table_sendPort')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('shop-site::email::table_sendPort') + '：'" prop="outPort">
          <el-input
            v-model.trim="params.outPort"
            class="input-item"
            :placeholder="$t('shop-site::email::placeholder_emailPort')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('shop-site::email::table_protocol') + '：'" prop="outProtocol">
          <el-select
            v-model="params.outProtocol"
            :popperAppendToBody="false"
            class="input-item"
            :placeholder="$t('shop-site::email::placeholder_protocol')"
            :popper-append-to-body="false"
          >
            <el-option v-for="item in protocols" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="sec-box" v-show="showMore">
        <div class="sec-header">{{ $t('shop-site::email::recieveSetting') }}</div>
        <el-form-item :label="$t('shop-site::email::table_recieveType') + '：'" prop="inAccountType">
          <el-select
            v-model="params.inAccountType"
            :popperAppendToBody="false"
            class="input-item"
            :placeholder="$t('shop-site::email::placeholder_emailType')"
            :popper-append-to-body="false"
          >
            <el-option v-for="item in emailTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('shop-site::email::table_recieveAddress') + '：'" prop="inServer">
          <el-input
            v-model.trim="params.inServer"
            class="input-item"
            :placeholder="$t('shop-site::email::placeholder_emailAddress')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('shop-site::email::table_recievePort') + '：'" prop="inPort">
          <el-input
            v-model.trim="params.inPort"
            class="input-item"
            :placeholder="$t('shop-site::email::placeholder_emailPort')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('shop-site::email::table_protocol') + '：'" prop="inProtocol">
          <el-select
            v-model="params.inProtocol"
            :popperAppendToBody="false"
            class="input-item"
            :placeholder="$t('shop-site::email::placeholder_protocol')"
            :popper-append-to-body="false"
          >
            <el-option v-for="item in protocols" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-form>

    <div slot="footer" class="dialog-footer" v-show="showEmailForm">
      <el-button @click="onChange">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button type="primary" @click="onSave" :loading="saveLoading">
        {{ $t('system::common::btn::confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { EMAIL_TYPE, PROTOCOL, PLATFORM, PLATFORM_LIST } from '@/config'
import { updateServiceEmail, getEmailShopList, getEmailList } from '@/server/after-sales.js'
import { getAuthAllUser } from '@/server/system.js'
export default {
  name: 'modal-email',
  components: {},
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: {
      default: false,
    },
    drawRow: {
      default: () => {},
    },
  },
  watch: {
    visible(bool) {
      this.show = bool
      let data = this.drawRow
      if (bool) {
        this.selectEmail = null
        this.showMore = false
        if (data.type === 'add') {
          this.params = {
            inAccountType: 'imap',
            inServer: '',
            inPort: '143',
            inProtocol: 'default',
            outAccountType: 'smtp',
            outServer: '',
            outPort: '465',
            outProtocol: 'SSL',
            inUser: '',
            inPassword: '',
            shopId: '',
            staffId: '',
            platform: '',
          }
        } else {
          console.log('data.item', data.item)
          this.params = {
            ...data.item,
          }
          this.showMore = true
        }
      }
      this.$nextTick(() => this.$refs.form.clearValidate())
    },
    drawRow: {
      handler: function (data) {},
      deep: true,
    },
  },
  data() {
    return {
      emailImg: {
        1: require('@/assets/images/email/wangyi.png'),
        2: require('@/assets/images/email/QQmail.png'),
        3: require('@/assets/images/email/godady.png'),
        4: require('@/assets/images/email/qita.png'),
      },
      emailList: [],
      selectEmail: null,
      loading: false,
      saveLoading: false,
      emailTypes: EMAIL_TYPE,
      protocols: PROTOCOL,
      shopIds: [],
      platform: PLATFORM,
      platformLists: PLATFORM_LIST,
      users: [],
      rules: {
        inAccountType: [
          { required: true, message: this.$t('shop-site::email::placeholder_emailType'), trigger: 'change' },
        ],
        inServer: [
          { required: true, message: this.$t('shop-site::email::placeholder_emailAddress'), trigger: 'change' },
        ],
        inPort: [{ required: true, message: this.$t('shop-site::email::placeholder_emailPort'), trigger: 'change' }],
        inProtocol: [{ required: true, message: this.$t('shop-site::email::placeholder_protocol'), trigger: 'change' }],
        outAccountType: [
          { required: true, message: this.$t('shop-site::email::placeholder_emailType'), trigger: 'change' },
        ],
        outServer: [
          { required: true, message: this.$t('shop-site::email::placeholder_emailAddress'), trigger: 'change' },
        ],
        outPort: [{ required: true, message: this.$t('shop-site::email::placeholder_emailPort'), trigger: 'change' }],
        outProtocol: [
          { required: true, message: this.$t('shop-site::email::placeholder_protocol'), trigger: 'change' },
        ],
        inUser: [
          { required: true, message: this.$t('shop-site::email::placeholder_account'), trigger: 'change' },
          { type: 'email', message: this.$t('shop-site::email::placeholder_rightAccount') },
        ],
        inPassword: [{ required: true, message: this.$t('shop-site::email::placeholder_password'), trigger: 'change' }],
        shopId: [{ required: true, message: this.$t('shop-site::email::placeholder_shop'), trigger: 'change' }],
        staffId: [{ required: true, message: this.$t('shop-site::email::placeholder_staff'), trigger: 'change' }],
        platform: [{ required: true, message: this.$t('shop-site::email::placeholder_platform'), trigger: 'change' }],
      },
      showMore: false,
      show: false,
      params: {},
    }
  },
  computed: {
    showEmailForm() {
      if (this.drawRow.type !== 'add') {
        return true
      } else {
        return !!this.selectEmail
      }
    },
  },
  mounted() {
    this.getLeaderList()
    this.getShopListInfo()
    this.getEmailList()
  },
  methods: {
    changeShop(value) {
      const platform = this.shopIds.find(i => i.value === value) && this.shopIds.find(i => i.value === value).platform
      this.params.platform = platform || ''
    },
    async getLeaderList() {
      this.loading = true
      const { data } = await getAuthAllUser({ userId: this.$store.state.user.merchantId, containUser: true })
      console.log(data, 'day')
      if (data.code === this.$code) {
        this.users = data.data.map(item => {
          return {
            label: item.userName,
            value: item.userId,
          }
        })
      }
      this.loading = false
    },
    async getShopListInfo() {
      this.loading = true
      const { data } = await getEmailShopList()
      if (data.code === this.$code) {
        this.shopIds = data.data.map(item => {
          return {
            label: item.shopName,
            value: item.shopId,
            platform: item.mallType,
          }
        })
      }
      this.loading = false
    },
    async getEmailList() {
      this.loading = true
      const { data } = await getEmailList()
      if (data.code === this.$code) {
        this.emailList = data.data.sort((a, b) => {
          return a.orderField - b.orderField
        })
        this.emailList[this.emailList.length - 1] = { ...this.emailList[this.emailList.length - 1], isOther: true }
      }
      this.loading = false
    },
    selectDefaultEmail(item) {
      this.selectEmail = item
      if (item.isOther) {
        this.showMore = true
      } else {
        this.params = {
          ...this.params,
          inAccountType: this.selectEmail.receiveServerType,
          inServer: this.selectEmail.receiveServer,
          inPort: this.selectEmail.receivePort,
          inProtocol: this.selectEmail.receiveEncryptionProtocol,
          outAccountType: this.selectEmail.sendServerType,
          outServer: this.selectEmail.sendServer,
          outPort: this.selectEmail.sendPort,
          outProtocol: this.selectEmail.sendEncryptionProtocol,
        }
      }
    },
    onChange() {
      if (this.drawRow.type === 'add' && this.showEmailForm) {
        this.showEmailForm = false
        this.selectEmail = null
        this.params = {
          inAccountType: 'imap',
          inServer: '',
          inPort: '143',
          inProtocol: 'default',
          outAccountType: 'smtp',
          outServer: '',
          outPort: '465',
          outProtocol: 'SSL',
          inUser: '',
          inPassword: '',
          shopId: '',
          staffId: '',
          platform: '',
        }
      } else {
        this.$emit('change', false)
      }
    },
    onSave() {
      this.$refs['form'].validate(async valid => {
        console.log('数据：：', this.params)
        if (valid) {
          const params = {
            inAccountType: this.params.inAccountType,
            inServer: this.params.inServer,
            inPort: this.params.inPort,
            inProtocol: this.params.inProtocol,
            outAccountType: this.params.outAccountType,
            outServer: this.params.outServer,
            outPort: this.params.outPort,
            outProtocol: this.params.outProtocol,
            inUser: this.params.inUser,
            inPassword: this.params.inPassword,
            shopId: this.params.shopId,
            outUser: this.drawRow.type === 'edit' ? this.params.outUser : this.params.inUser,
            platform: this.params.platform,
            outPassword: this.drawRow.type === 'edit' ? this.params.outPassword : this.params.inPassword,
            staffId: this.params.staffId,
          }
          if (this.drawRow.type === 'edit') {
            params.id = this.params.id
          }
          this.saveLoading = true
          const { data } = await updateServiceEmail(params)
          this.saveLoading = false
          if (data.code === this.$code) {
            if (data.data && (data.data.code === 701 || data.data.code === 702)) {
              this.$confirm(data.data.msg, this.$t('shop-site::email::confirm_title'), {
                confirmButtonText: this.$t('shop-site::email::confirm_return'),
                cancelButtonText: this.$t('shop-site::email::confirm_agian'),
                showClose: false,
                closeOnClickModal: false,
              }).catch(() => {
                this.onSave()
              })
              return
            }
            this.$message.success(this.$t('system::tip::control_success'))
            await this.$store.dispatch('getBindData')
            this.$emit('save')
            this.$emit('change', false)
          }
        }
      })
    },
    handleCheck(type) {
      this.params.type = type
    },
  },
}
</script>
<style lang="scss" scoped>
.user-bind-modal {
  .email-body {
    .input-item {
      width: 100%;
    }
  }
  .sec-header {
    padding: 0 0 12px 0;
    border-bottom: 1px solid #dcdfe6;
    margin-bottom: 16px;
  }
  .sec-box {
    background: #f9f9f9;
    padding: 16px;
    &:last-child {
      margin-top: 16px;
    }
  }
  .no-bg {
    background-color: inherit;
  }
  .check-info {
    margin-bottom: 10px;
  }
  .tip-info {
    color: $--color-info;
  }
}

.emailType {
  width: 160px;
  height: 60px;
  border-radius: 5px;
  border: 1px solid #aaaaaa;
  margin-bottom: 10px;
  img {
    width: 160px;
    height: 60px;
    cursor: pointer;
  }
}
.rotate-arrow {
  display: inline-block;
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
}
</style>
